import _Input from "@alifd/next/es/input";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import * as React from 'react';
import './index.less';
var StringSetter = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(StringSetter, _React$PureComponent);
  function StringSetter() {
    return _React$PureComponent.apply(this, arguments) || this;
  }
  var _proto = StringSetter.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      _onChange = _this$props.onChange,
      placeholder = _this$props.placeholder,
      value = _this$props.value;
    return /*#__PURE__*/React.createElement(_Input, {
      size: "small",
      value: value,
      placeholder: placeholder || '',
      onChange: function onChange(val) {
        return _onChange(val);
      },
      style: {
        width: '100%'
      }
    });
  };
  return StringSetter;
}(React.PureComponent);
StringSetter.displayName = 'StringSetter';
export { StringSetter as default };